module.exports = __webpack_public_path__ + "static/media/a8.35c8cf0d.jpg";